/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types'
import { truncate } from 'lodash'
import RelatedCard from '~/components/shared/RelatedCard'
import OrganizationLink from '~/components/shared/OrganizationLink'
import { tField } from '~/utils/translations'
import { formatISOdate } from '~/utils/format'

import styles from './index.module.scss'

const AgendaItemRelatedCard = ({ agendaItem }) => (
  <RelatedCard className={styles.card}>
    <OrganizationLink href={`meetings/${agendaItem.meeting.id}`}>
      <a className={styles.meetingLink}>
        <span>{formatISOdate(agendaItem.meeting.date, 'MMM d, yyyy')}</span>
        <strong>{tField(agendaItem?.meeting, 'title')}</strong>
      </a>
    </OrganizationLink>
    <OrganizationLink href={`agenda-items/${agendaItem.id}`}>
      <a className={styles.agendaItemLink}>
        <img src="/images/subitem-grey.svg" alt="" />
        {!!agendaItem?.agendaSequence && (
          <strong className="text-primary text-uppercase">{agendaItem?.agendaSequence}. </strong>
        )}
        <span>{truncate(tField(agendaItem, 'title'), { length: 100 })}</span>
      </a>
    </OrganizationLink>
  </RelatedCard>
)

AgendaItemRelatedCard.propTypes = {
  agendaItem: PropTypes.shape({
    id: PropTypes.number,
    agendaSequence: PropTypes.string,
    meeting: PropTypes.shape({
      id: PropTypes.number.isRequired,
      date: PropTypes.string.isRequired
    })
  }).isRequired
}

export default AgendaItemRelatedCard
